<script>

    import layer3d from "@/mixins/threeBoxLayer"

    export default{

        mixins:[layer3d],
        
        name:"caixa",

        data(){
            return {
                loadDelay:0,
                modelName:"caixa",
                modelDir:"/models3d/",
                rotation:[90,0,180,'ZXY'],
                scale:[9,9,9],
                zoomScaleFactor:[[9,13],[16,0.7]],
                coordinates: [-47.88373878167329,-15.802767893580324]
            }
        },

        computed:{

            geoJSON:function(){
                return {
                    "type": "FeatureCollection",
                    "features": [{
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates":this.coordinates
                        },
                        "properties":{
                            key:"caixa",
                            scale:this.scale,//[5,5,5],
                            rotation:this.rotation,//[0,0,7,'XYZ'],
                            zoomScaleFactor:this.zoomScaleFactor,//[0,0,7,'XYZ'],
                            // rotation: ()=> 
                        }
                    } ]
                }
            },
        },


        watch:{
            geoJSON:function(){

                // this.animatePoints(4, false)
            }
        },

        methods:{

        },

        style: function () {
            return {
                "type": "symbol",
                "layout": {
                    "icon-image": ["get", "icon"], //['case', ['==',['get','index'],0], 'largada','pis'],  //"pis",
                    "icon-anchor": "center",
                    "icon-allow-overlap": true,
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [8.9, 0.1],
                            [11, 0.5],
                            [14, 1.3]
                        ]
                    },
                },
                "paint": {
                    "icon-opacity": {
                        "base": 1,
                        "stops": [[11.3, 0], [11.4, 1]],
                    },
                }
            }
        }
    }


</script>